<template>
  <umkm-component />
</template>
    
<script>
import UmkmComponent from "../components/umkm/Index.vue";
export default {
  name: "Login",
  components: {
    UmkmComponent,
  },
  data: () => ({}),
};
</script>
    
<style>
</style>